export const APP_SENTRYDSN: string = 'https://8a5d1de1deeb434da0e8d5467deadc4e@o438327.ingest.sentry.io/5414389';
export const REACT_APP_ENV: string = 'prod';
